module.exports = __webpack_public_path__ + "static/img/davis_pictgrid22_960x858.756d5bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid22_960x858.jpg
// module id = v87s
// module chunks = 0